<template>
    <section class="dp-layout class-affair-record">
        <section class="dp-left">
            <DepartmentPane directory-scope="teaching" pane-title="组织架构" default-select-root @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>
        <section class="dp-right" v-if="schoolId > 0">
            <div class="scope-hint" v-if="scopeLabel">当前：{{ scopeLabel }}</div>
            <el-form :inline="true" size="small" class="toolbar">
                <el-form-item label="时段">
                    <el-select v-model="query.windowId" clearable placeholder="全部" style="width:260px" @change="load(1)">
                        <el-option v-for="w in windows" :key="w.Id" :label="windowLabel(w)" :value="w.Id" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        v-if="hasActionPermission('handleExport')"
                        type="success"
                        size="small"
                        icon="el-icon-download"
                        :loading="exporting"
                        @click="handleExport"
                    >导出</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="rows" v-loading="loading" border size="small" class="record-table">
                <el-table-column prop="WindowTitle" label="名称" min-width="140" show-overflow-tooltip />
                <el-table-column label="起止" min-width="180" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.StartDate }} ~ {{ scope.row.EndDate }}</template>
                </el-table-column>
                <el-table-column prop="CampusName" label="校区" min-width="110" show-overflow-tooltip />
                <el-table-column prop="ClassName" label="班级" min-width="110" show-overflow-tooltip />
                <el-table-column prop="TeacherName" label="提交人" min-width="100" show-overflow-tooltip />
                <el-table-column label="班级分" min-width="90" align="center">
                    <template slot-scope="scope">
                        <span class="score-text">+{{ formatScore(scope.row.Score) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="CreateTime" label="提交时间" min-width="160" show-overflow-tooltip />
                <el-table-column label="操作" width="90" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" class="op-link" @click="openDetail(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="pager"
                background
                layout="total, prev, pager, next"
                :current-page="page"
                :page-size="pageSize"
                :total="total"
                @current-change="load"
            />
        </section>
        <section class="dp-right" v-else><div class="empty-tip">请在左侧选择部门</div></section>

        <el-dialog
            title="提交内容"
            :visible.sync="detailVisible"
            width="680px"
            :close-on-click-modal="false"
            append-to-body
            custom-class="class-affair-detail-dialog"
        >
            <div v-if="detail" class="detail-body">
                <div class="detail-meta">
                    <el-tag size="small" effect="plain">{{ detail.ClassName || '-' }}</el-tag>
                    <el-tag size="small" type="info" effect="plain">{{ detail.WindowTitle || '-' }}</el-tag>
                    <span v-if="detail.Score != null" class="detail-meta__score">班级分 +{{ formatScore(detail.Score) }}</span>
                    <span v-if="detail.TeacherName" class="detail-meta__stat">{{ detail.TeacherName }}</span>
                    <span v-if="detail.CreateTime" class="detail-meta__stat">{{ detail.CreateTime }}</span>
                </div>
                <div class="detail-section">
                    <div class="detail-section__title">正文</div>
                    <div class="detail-section__body" :class="{ empty: !detail.Content }">{{ detail.Content || '未填写' }}</div>
                </div>
                <div class="detail-section">
                    <div class="detail-section__title">备注</div>
                    <div class="detail-section__body" :class="{ empty: !detail.Remark }">{{ detail.Remark || '未填写' }}</div>
                </div>
                <div class="detail-section">
                    <div class="detail-section__title">图片</div>
                    <div v-if="detail.Photos && detail.Photos.length" class="photo-grid">
                        <el-image
                            v-for="(url, i) in detail.Photos"
                            :key="i"
                            :src="url"
                            :preview-src-list="detail.Photos"
                            class="photo"
                            fit="cover"
                        />
                    </div>
                    <div v-else class="detail-section__body empty">未上传</div>
                </div>
            </div>
            <span slot="footer">
                <el-button type="primary" size="small" @click="detailVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import { getButtonList } from '../../promissionRouter';
import { getClassAffairWindows, getClassAffairRecords, exportClassAffairRecords } from '../../api/modules/classAffair';

export default {
    name: 'ClassAffairRecord',
    components: { DepartmentPane },
    data() {
        return {
            schoolId: 0,
            departmentId: 0,
            scopeLabel: '',
            buttonList: [],
            windows: [],
            query: { windowId: null },
            rows: [],
            loading: false,
            exporting: false,
            page: 1,
            pageSize: 20,
            total: 0,
            detailVisible: false,
            detail: null
        };
    },
    created() {
        this.buttonList = getButtonList(this.$route.path) || [];
    },
    methods: {
        hasActionPermission(func) {
            if (!this.buttonList || !this.buttonList.length) return true;
            return this.buttonList.some(button => button.Func === func);
        },
        findAncestorDeptId(node, orgType) {
            let cur = node;
            const target = String(orgType || '').toLowerCase();
            while (cur) {
                const row = cur.data || cur;
                const type = String((row.DeptOrgType || row.deptOrgType) || '').toLowerCase();
                if (type === target) {
                    const id = row.value != null ? row.value : row.Id;
                    return id && String(id) !== '0' ? id : 0;
                }
                cur = cur.parent;
            }
            return 0;
        },
        async treeNodeClick(data, node) {
            if (!data) return;
            const orgType = String(data.DeptOrgType || data.deptOrgType || '').toLowerCase();
            const deptId = data.value != null ? data.value : data.Id;
            if (!deptId || String(deptId) === '0') return;
            const schoolId = orgType === 'school' || orgType === 'affiliateschool'
                ? deptId
                : (this.findAncestorDeptId(node, 'school')
                    || this.findAncestorDeptId(node, 'affiliateschool')
                    || this.schoolId);
            if (!schoolId) return;
            const schoolChanged = String(this.schoolId) !== String(schoolId);
            this.schoolId = schoolId;
            this.departmentId = deptId;
            this.scopeLabel = data.label || data.Name || '';
            if (schoolChanged) {
                this.query.windowId = null;
                await this.loadWindows();
            }
            this.load(1);
        },
        windowLabel(w) {
            return (w.Title || w.ItemTypeName || '') + ' ' + w.StartDate + '~' + w.EndDate;
        },
        formatScore(val) {
            if (val === null || val === undefined || val === '') return '-';
            const n = Number(val);
            if (isNaN(n)) return val;
            return Number.isInteger(n) ? String(n) : n.toFixed(2);
        },
        async loadWindows() {
            const res = await getClassAffairWindows({ schoolId: this.schoolId });
            this.windows = res.data && res.data.success ? (res.data.response || []) : [];
        },
        async load(page) {
            this.page = page || 1;
            this.loading = true;
            try {
                const res = await getClassAffairRecords({
                    schoolId: this.schoolId,
                    departmentId: this.departmentId || 0,
                    windowId: this.query.windowId || 0,
                    page: this.page,
                    intPageSize: this.pageSize
                });
                if (res.data && res.data.success) {
                    const body = res.data.response || {};
                    this.rows = body.data || [];
                    this.total = body.dataCount || 0;
                } else {
                    this.rows = [];
                    this.$message.error((res.data && res.data.msg) || '加载失败');
                }
            } finally {
                this.loading = false;
            }
        },
        openDetail(row) {
            this.detail = row;
            this.detailVisible = true;
        },
        async handleExport() {
            if (!this.schoolId) {
                this.$message.warning('请先选择部门');
                return;
            }
            this.exporting = true;
            try {
                const res = await exportClassAffairRecords({
                    schoolId: this.schoolId,
                    departmentId: this.departmentId || 0,
                    windowId: this.query.windowId || 0
                });
                const blob = res.data;
                if (blob && blob.type && blob.type.indexOf('application/json') >= 0) {
                    const text = await blob.text();
                    let msg = '导出失败';
                    try {
                        const json = JSON.parse(text);
                        msg = json.msg || msg;
                    } catch (err) { /* ignore */ }
                    this.$message.error(msg);
                    return;
                }
                if (!blob || blob.size === 0) {
                    this.$message.warning('没有数据可导出');
                    return;
                }
                const url = window.URL.createObjectURL(new Blob([blob], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                const link = document.createElement('a');
                link.href = url;
                link.download = `班务记录_${new Date().toISOString().slice(0, 10)}.xlsx`;
                link.click();
                window.URL.revokeObjectURL(url);
                this.$message.success('导出成功');
            } catch (e) {
                this.$message.error('导出失败');
            } finally {
                this.exporting = false;
            }
        }
    }
};
</script>

<style scoped>
.scope-hint { margin-bottom: 8px; color: #606266; font-size: 13px; }
.toolbar { margin-bottom: 8px; }
.record-table >>> .el-table__header,
.record-table >>> .el-table__body { width: 100% !important; }
.score-text { color: #67c23a; font-weight: 600; }
.op-link { color: #409eff; }
.pager { margin-top: 12px; text-align: right; }
.empty-tip { padding: 80px 0; text-align: center; color: #909399; }
</style>

<style>
.class-affair-detail-dialog .el-dialog__body {
    padding: 14px 20px 8px;
}
.class-affair-detail-dialog .detail-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 14px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eef2f6;
}
.class-affair-detail-dialog .detail-meta__score {
    color: #67c23a;
    font-size: 13px;
    font-weight: 600;
}
.class-affair-detail-dialog .detail-meta__stat {
    color: #909399;
    font-size: 12px;
}
.class-affair-detail-dialog .detail-section {
    margin-bottom: 14px;
}
.class-affair-detail-dialog .detail-section__title {
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
    letter-spacing: 0.02em;
}
.class-affair-detail-dialog .detail-section__body {
    background: #f8fafc;
    border: 1px solid #eef2f6;
    border-radius: 8px;
    padding: 10px 12px;
    color: #303133;
    white-space: pre-wrap;
    line-height: 1.6;
    min-height: 40px;
}
.class-affair-detail-dialog .detail-section__body.empty {
    color: #c0c4cc;
}
.class-affair-detail-dialog .photo-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
.class-affair-detail-dialog .photo {
    width: 88px;
    height: 88px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e8edf3;
    cursor: pointer;
}
</style>
